/**
 * De melding bij mogelijke duplicaten na het aanmaken van een klant.
 *
 * De backend bepaalt de duplicaten (klant_service, canonieke dedupe) en wat de gebruiker ervan
 * mag zien: een treffer bij een collega komt zonder naam (bij_collega). Hier alleen de tekst;
 * geen duplicaten: null.
 */
export function duplicaatMelding(t, duplicaten) {
  if (!Array.isArray(duplicaten) || duplicaten.length === 0) return null
  const namen = duplicaten
    .map((d) => (d.bij_collega ? t('klanten.duplicaat.bijCollega') : d.naam))
    .filter(Boolean)
    .join(', ')
  return t('klanten.duplicaat.melding', { namen })
}
